module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kathy Douglass\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kathy Douglass came by her love of reading naturally - both of her parents were readers. She would finish one book and pick up another. Then she attended law school and traded romances for legal opinions."), _c('Br', [_c('Br', [_vm._v("After the birth of her two children, her love of reading turned into a love of writing. Kathy now spends her days writing the small town comtemporary novels she enjoys reading."), _c('Br', [_c('Br', [_vm._v("Kathy loves to hear from her readers and can be found on Facebook.")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Hl4dnR/tc-custom/9781488014512.jpg?1738351578834",
      "alt": "This image is the cover for the book Waitress's Secret, Sweet Briar Sweethearts"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Waitress's Secret, Sweet Briar Sweethearts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this southern small town romance, an heiress posing as waitress fears revealing her true identity to the chef she’s falling in love with.")]), _c('br'), _c('br'), _vm._v("On the run after a bad breakup, wealthy city girl Arden Wexford ends up stranded in the small town of Sweet Briar. When hunky chef Brandon Danielson comes to her rescue, offering shelter and a waitressing job until her car is fixed, she reluctantly accepts. But, wanting Brandon to like her for herself, not for her money, she doesn’t mention her rich roots. The closer they get, the harder it is to reveal her secret."), _c('br'), _c('br'), _vm._v("Brandon came to Sweet Briar start over after his broken engagement. Things weren’t as they seemed with his ex-fiancée, and he got burned! His feelings for Arden are starting to become very real. But are his trust issues keeping him from getting closer, or is it something else?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0